import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from "react-router-dom";
import PaymentWrapper from "./components/onePay/payment/PaymentWrapper";
import PostbackWrapper from "./components/onePay/postback/PostbackWrapper";
import BadRequest from "./components/onePay/error/BadRequest";
import Unauthorized from "./components/onePay/error/Unauthorized";
import InternalError from "./components/onePay/error/InternalError";
import NotFound from "./components/onePay/error/NotFound";

const OnePayApp = props => {

    return (
        <Router>
            <Switch>
                <Route exact path="/" component={PaymentWrapper} />
                <Route exact path="/postback" component={PostbackWrapper} />
                <Route exact path="/bad-request" component={BadRequest} />
                <Route exact path="/unauthorized" component={Unauthorized} />
                <Route exact path="/internal-server-error" component={InternalError} />
                <Route exact path="/*" component={NotFound} />
            </Switch>
        </Router>
    );

}

export default OnePayApp;
